import { useState, useRef, useContext, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FContext from "./context/Context";
import { useNavigate } from "react-router-dom";
import "./RegForm.scss";
import classes from "./RegForm.module.css";
import OtpInput from "react18-input-otp";
import axios from "axios";
import Navbar from "./Navbar";
import Footer from "./Footer";

const RegForm = (props) => {
  // DECLARE BASE URL
  const base_url = process.env.REACT_APP_BASE_URL;
  console.log(base_url)

  const navigate = useNavigate();
  const [corperInvestType, setCorperInvestType] = useState("Regular");
  const [error, setError] = useState(null);
  const [bankList, setBankList] = useState([]);
  const [bankVal, setBankVal] = useState();
  const [titleList, setTitleList] = useState([]);
  const [relationshipList, setRelationshipList] = useState([]);
  const [lgaList, setLgaList] = useState([]);
  const [lgList, setLgList] = useState([]);
  const [lgaVal, setLgaVal] = useState();
  const [countryList, setCountryList] = useState([]);
  const [countryVal, setCountryVal] = useState();
  const [nationalityList, setNationalityList] = useState([]);
  const [nationalityVal, setNationalityVal] = useState();
  const [stateList, setStateList] = useState([]);
  const [stList, setStList] = useState([]);
  const [nokLGA, setNOKLGA] = useState([]);
  const [employerState, setEmployerState] = useState([]);
  const [stateVal, setStateVal] = useState({});
  const [selectLga, setSelectLga] = useState(true);
  const [showPage2, setShowPage2] = useState(false);
  const [payload, setPayload] = useState();
  const [employmentStatus, setEmploymentStatus] = useState();

  useEffect(() => {
    setCorperInvestType("Regular");
    setError(null);
    axios.get().then(() => { }).catch()
    const fecthData = async () => {
      try {
        const returnData = await fetch(
          "./data/dropdown-options.json"
          // "http://10.10.10.46:8321/nsl/dropdown-options"
          // `${base_url}/nsl/dropdown-options`
        );

        if (!returnData.ok) {
          toast.error(" Lost connection, please try again later!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }

        const data = await returnData.json();

        for (const dat of data.titles.title) {
          setTitleList((prev) => {
            return [...prev, dat];
          });
        }

        for (const dat of data.relationship.relation) {
          setRelationshipList((prev) => {
            return [...prev, dat];
          });
        }

        for (const dat of data.banks.bank) {
          setBankList((prev) => {
            return [...prev, dat];
          });
        }

        for (const dat of data.lga.lga) {
          setLgaList((prev) => {
            return [...prev, dat];
          });
        }

        for (const dat of data.countries.country) {
          setCountryList((prev) => {
            return [...prev, dat];
          });
        }

        for (const dat of data.nationality.nation) {
          setNationalityList((prev) => {
            return [...prev, dat];
          });
        }

        for (const dat of data.states.state) {
          setStateList((prev) => {
            return [...prev, dat];
          });
        }
      } catch (error) {
        toast.error(" Lost connection, please try again later!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    };
    fecthData();
  }, []);

  // console.log(stateList);
  const formCtx = useContext(FContext);

  //console.log(formCtx.formData);

  //Form Validations
  const [bvnValid, setBvnValid] = useState(true);
  const [bvn, setBvn] = useState("");
  const [titleValid, setTitleValid] = useState(true);
  const [firstNameValid, setFirstNameValid] = useState(true);
  const [lastNameValid, setLastNameValid] = useState(true);
  const [otherNameValid, setOtherNameValid] = useState(true);
  const [phoneNumberValid, setPhoneNumberValid] = useState(true);
  const [emailValid, setEmailValid] = useState(true);
  const [countryValid, setCountryValid] = useState(true);
  const [stateValid, setStateValid] = useState(true);
  const [lgaValid, setLgaValid] = useState(true);
  const [nokEmailValid, setNokEmailValid] = useState(true);
  const [nationalityValid, setNationalityValid] = useState(true);
  const [contactValid, setContactValid] = useState(true);
  const [genderValid, setGenderValid] = useState(true);
  const [dobValid, setDobValid] = useState(true);
  const [bankValid, setBankValid] = useState(true);
  const [maidenValid, setMaidenValid] = useState(true);
  const [accountValid, setAccountValid] = useState(true);
  const [accountNumber, setAccountNumber] = useState("");
  const [accountNumberValid, setAccountNumberValid] = useState(true);
  const [nokFirstNameValid, setNokFirstNameValid] = useState(true);
  const [nokLastNameValid, setNokLastNameValid] = useState(true);
  const [nokRelationshipValid, setNokRelationshipValid] = useState(true);
  const [nokGenderValid, setNokGenderValid] = useState(true);
  const [nokContactAddressValid, setNokContactAddressValid] = useState(true);
  const [nokStateValid, setNokStateValid] = useState(true);
  const [nokCountryValid, setNokCountryValid] = useState(true);
  const [nokPhoneNumberValid, setNokPhoneNumberValid] = useState(true);
  const [employmentValid, setEmploymentValid] = useState(true);
  const [employerNameValid, setEmployerNameValid] = useState(true);
  const [employerCountryValid, setEmployerCountryValid] = useState(true);
  const [employerStateValid, setEmployerStateValid] = useState(true);
  const [employerContactAddressValid, setEmployerContactAddressValid] = useState(true);
  const [designationValid, setDesignationValid] = useState(true);
  const [jobTitleValid, setJobTitleValid] = useState(true);
  const [completedValue, setCompletedValue] = useState({});

  const [updates, setUpdates] = useState(false);
  const [formValid, setFormValid] = useState();

  const [gend, setGend] = useState();
  const [dob, setDob] = useState();
  const [st, setSt] = useState();
  const [lg, setLg] = useState();
  const [bk, setBk] = useState();
  const [nokRelation, setNokRelation] = useState();
  const [nokGend, setNokGend] = useState();

  const title = useRef();
  const firstName = useRef();
  const lastName = useRef();
  const otherName = useRef();
  const phoneNumber = useRef();
  const email = useRef();
  const contactAddress = useRef();
  const gender = useRef();
  const dateOfBirth = useRef();
  const employment = useRef();
  const maidenName = useRef();
  const bank = useRef();
  const accountName = useRef();
  const nokFirstName = useRef();
  const nokLastName = useRef();
  const nokRelationship = useRef();
  const nokPhoneNumber = useRef();
  const nokEmailAddress = useRef();
  const nokContactAddress = useRef();
  const employerContactAddress = useRef();
  const state = useRef();
  const country = useRef();
  const nokGender = useRef();
  const nokState = useRef();
  const employerCountry = useRef();
  const employerName = useRef();
  const jobTitle = useRef();
  const designation = useRef();
  const nokCountry = useRef();
  const lga = useRef();
  const nationality = useRef();

  const nokStateChangeHandler = () => {
    const nokStateValue = nokState.current.value;

    if (nokStateValue === "" || nokStateValue === "State") {
      setNokStateValid(false);
    } else {
      setNokStateValid(true);
    }
  };
  const employerStateChangeHandler = () => {
    const employerStateValue = employerState.current.value;

    if (employerStateValue === "" || employerStateValue === "State") {
      setEmployerStateValid(false);
    } else {
      setEmployerStateValid(true);
    }
  };
  const nokCountryChangeHandler = (id) => {
    const nokCountryValue = nokCountry.current.value;

    const lg = stateList.filter((lga) => lga.COUNTRY_CD === id);
    console.log(lg);

    //setStList(lg);
    setNOKLGA(lg);
    console.log(stList);

    if (nokCountryValue === "" || nokCountryValue === "Country") {
      setNokCountryValid(false);
    } else {
      setNokCountryValid(true);
    }
  };
  const employerCountryChangeHandler = (id) => {
    const employerCountryValue = employerCountry.current.value;

    const state = stateList.filter((lga) => lga.COUNTRY_CD === id);
    console.log(state);

    //setStList(lg);
    setEmployerState(state);

    if (employerCountryValue === "" || employerCountryValue === "Country") {
      setEmployerCountryValid(false);
    } else {
      setEmployerCountryValid(true);
    }
  };

  const nokGenderChangeHandler = () => {
    const nokGenderValue = nokGender.current.value;

    setNokGend(nokGenderValue);

    if (nokGenderValue === "" || nokGenderValue === "Gender") {
      setNokGenderValid(false);
    } else {
      setNokGenderValid(true);
    }
  };

  // data of birth
  const dobChangeHandler = () => {
    const dobValue = dateOfBirth.current.value;
    setDob(dobValue);
    console.log(dobValue)

    if (dobValue === "" || dobValue === "date of birth") {
      setDobValid(false);
      dateOfBirth.current.type = 'text';

    } else {
      setDobValid(true);
    }
  };

  const dobOnFocusHandler = () => {
    dateOfBirth.current.type = 'date';
    dateOfBirth.current.click();
  };

  // end date of birth scope

  const employmentChangeHandler = () => {
    const employmentValue = employment.current.value;

    setEmploymentStatus(employmentValue);

    if (employmentValue === "" || employmentValue === "Employment Status") {
      setEmploymentValid(false);
    } else {
      setEmploymentValid(true);
    }
  };

  const lgaChangeHandler = () => {
    const lgaValue = lga.current.value;
    // setLgaList

    setLg(lgaValue);

    if (lgaValue === "" || lgaValue === "Select LGA") {
      setLgaValid(false);
    } else {
      setLgaValid(true);
    }
  };

  const maidenNameChangeHandler = () => {
    const maidenNameValue = maidenName.current.value;

    if (maidenNameValue === "") {
      setMaidenValid(false);
    } else {
      setMaidenValid(true);
    }
    console.log(maidenNameValue);
  };

  const stateChangeHandler = (id) => {
    const stateValue = state.current.value;

    const lg = lgaList.filter((lga) => lga.STATE_CD === id);
    console.log(lg);

    setLgList(lg);
    console.log(lgList);

    setSt(stateValue);

    if (stateValue === "" || stateValue === "Select State") {
      setStateValid(false);
      setSelectLga(true);
    } else {
      setStateValid(true);
      setSelectLga(false);
    }
  };

  const countryChangeHandler = (id) => {
    const countryValue = country.current.value;

    const lg = stateList.filter((lga) => lga.COUNTRY_CD === id);
    console.log(lg);

    setStList(lg);
    console.log(stList);

    if (countryValue === "" || countryValue === "Select Country") {
      setCountryValid(false);
    } else {
      setCountryValid(true);
    }
  };

  const nationalityChangeHandler = (event) => {
    const nationalityValue = nationality.current.value;

    if (nationalityValue === "" || nationalityValue === "Select Nationality") {
      setNationalityValid(false);
    } else {
      setNationalityValid(true);
    }
  };

  const titleChangeHandler = (event) => {
    const titleValue = title.current.value;

    if (titleValue === "" || titleValue === "Select Title") {
      setTitleValid(false);
    } else {
      setTitleValid(true);
    }
  };

  const handleBvnChange = (enteredBvn) => {
    console.log(enteredBvn);
    setBvn(enteredBvn);

    if (bvn.length < 10 || isNaN(bvn)) {
      setBvnValid(false);
    } else {
      setBvnValid(true);
    }
  };

  const handleAccountNumberChange = (enteredNumber) => {
    setAccountNumber(enteredNumber);

    // console.log(event.current.value)

    if (accountNumber.length < 9 || isNaN(accountNumber)) {
      setAccountNumberValid(false);
    } else {
      setAccountNumberValid(true);
    }
  };

  const firstNameChangeHandler = () => {
    const firstNameVal = firstName.current.value;

    if (firstNameVal === "") {
      setFirstNameValid(false);
    } else {
      setFirstNameValid(true);
    }
  };

  const lastNameChangeHandler = () => {
    const lastNameVal = lastName.current.value;

    if (lastNameVal === "") {
      setLastNameValid(false);
    } else {
      setLastNameValid(true);
    }
  };

  const employerNameChangeHandler = () => {
    const employerNameVal = employerName.current.value;

    if (employerNameVal === "") {
      setEmployerNameValid(false);
    } else {
      setEmployerNameValid(true);
    }
  };
  const jobTitleChangeHandler = () => {
    const jobTitleVal = jobTitle.current.value;

    if (jobTitleVal === "") {
      setJobTitleValid(false);
    } else {
      setJobTitleValid(true);
    }
  };
  const designationChangeHandler = () => {
    const designationVal = designation.current.value;

    if (designationVal === "") {
      setDesignationValid(false);
    } else {
      setDesignationValid(true);
    }
  };
  const employerContactAddressChangeHandler = () => {
    const contactAddressVal = employerContactAddress.current.value;

    if (contactAddressVal === "") {
      setEmployerContactAddressValid(false);
    } else {
      setEmployerContactAddressValid(true);
    }
  };

  const phoneNumberChangeHandler = () => {
    const phoneNumberVal = phoneNumber.current.value;

    if (phoneNumberVal === "") {
      setPhoneNumberValid(false);
    } else {
      setPhoneNumberValid(true);
    }
  };

  const emailChangeHandler = () => {
    const reg = /^\S+@\S+\.\S+$/;
    const emailVal = email.current.value;
    const emailIsValid = !reg.test(emailVal);

    if (emailIsValid) {
      setEmailValid(false);
    } else {
      setEmailValid(true);
    }
  };

  const nokEmailChangeHandler = () => {
    const reg = /^\S+@\S+\.\S+$/;
    const emailVal = nokEmailAddress.current.value;
    const nokEmailIsValid = !reg.test(emailVal);

    if (nokEmailIsValid) {
      setNokEmailValid(false);
    } else {
      setNokEmailValid(true);
    }
  };

  const contactAddressChangeHandler = () => {
    const contactAddressVal = contactAddress.current.value;

    if (contactAddressVal === "") {
      setContactValid(false);
    } else {
      setContactValid(true);
    }
  };

  const genderChangeHandler = (e) => {
    const genderValue = gender.current.value;

    if (genderValue === "" || genderValue === "Select Gender") {
      setGenderValid(false);
    } else {
      setGenderValid(true);
      setGend(gender.current.value);
    }
  };

  const bankChangeHandler = (e) => {
    const bankValue = bank.current.value;

    setBk(bankValue);

    if (bankValue === "" || bankValue === "Select Bank") {
      setBankValid(false);
    } else {
      setBankValid(true);
    }
  };

  const accountNameChangeHandler = () => {
    const accountNameVal = accountName.current.value;

    if (accountNameVal === "") {
      setAccountValid(false);
    } else {
      setAccountValid(true);
    }
  };

  const nokFirstNameChangeHandler = () => {
    const nokFirstNameVal = nokFirstName.current.value;

    if (nokFirstNameVal === "") {
      setNokFirstNameValid(false);
    } else {
      setNokFirstNameValid(true);
    }
  };

  const nokLastNameChangeHandler = () => {
    const nokLastNameVal = nokLastName.current.value;

    if (nokLastNameVal === "") {
      setNokLastNameValid(false);
    } else {
      setNokLastNameValid(true);
    }
  };

  const nokRelationshipChangeHandler = () => {
    const relationshipValue = nokRelationship.current.value;

    setNokRelation(relationshipValue);

    if (relationshipValue === "" || relationshipValue === "Relationship") {
      setNokRelationshipValid(false);
    } else {
      setNokRelationshipValid(true);
    }

    console.log(relationshipValue);
  };

  const nokContactAddressChangeHandler = () => {
    const nokContactAddressVal = nokContactAddress.current.value;

    if (nokContactAddressVal === "") {
      setNokContactAddressValid(false);
    } else {
      setNokContactAddressValid(true);
    }
  };

  const nokPhoneNumberChangeHandler = () => {
    const nokPhoneNumberVal = nokPhoneNumber.current.value;

    if (nokPhoneNumberVal === "") {
      setNokPhoneNumberValid(false);
    } else {
      setNokPhoneNumberValid(true);
    }
  };

  const sendDataHandler = (event) => {
    event.preventDefault();

    const reg = /^\S+@\S+\.\S+$/;

    //const corperInvestType = corperInvestType;
    const titleValue = title.current.value;
    const firstNameVal = firstName.current.value;
    const lastNameVal = lastName.current.value;
    const otherNameVal = otherName.current.value;
    const phoneNumberVal = phoneNumber.current.value;
    const emailVal = email.current.value;
    const contactAddressVal = contactAddress.current.value;
    const genderValue = gender.current.value;
    // date of birth
    const dobValue = dateOfBirth.current.value;
    const bankVal = bank.current.value;
    const accountNameVal = accountName.current.value;
    const maidenNameValue = maidenName.current.value;
    const relationshipValue = nokRelationship.current.value;
    const nokFirstNameVal = nokFirstName.current.value;
    const nokLastNameVal = nokLastName.current.value;
    const nokPhoneNumberVal = nokPhoneNumber.current.value;
    const nokEmailAddressVal = nokEmailAddress.current.value;
    const nokContactAddressVal = nokContactAddress.current.value;
    const nationalityValue = nationality.current.value;
    const countryValue = country.current.value;
    const stateValue = state.current.value;
    const nokGenderValue = nokGender.current.value;
    const nokStateValue = nokState.current.value;
    const lgaValue = lga.current.value;
    const nokCountryValue = nokCountry.current.value;
    const emailIsValid = !reg.test(emailVal);
    if (
      bvn.length < 11 ||
      isNaN(bvn) ||
      titleValue === "" ||
      titleValue === "Select Title" ||
      accountNumber.length < 9 ||
      isNaN(accountNumber) ||
      firstNameVal === "" ||
      lastNameVal === "" ||
      phoneNumberVal === "" ||
      emailIsValid ||
      contactAddressVal === "" ||
      genderValue === "Select Gender" ||
      bankVal === "Select Bank" ||
      accountNameVal === "" ||
      countryValue === "" ||
      countryValue === "Select Country" ||
      stateValue === "" ||
      stateValue === "Select State" ||
      lgaValue === "" ||
      lgaValue === "Select LGA" ||
      nokFirstNameVal === "" ||
      nokLastNameVal === "" ||
      maidenNameValue === "" ||
      relationshipValue === "" ||
      relationshipValue === "Relationship" ||
      nokContactAddressVal === "" ||
      nokPhoneNumberVal === "" ||
      nokGenderValue === "" ||
      nokGenderValue === "Gender" ||
      nationalityValue === "" ||
      nationalityValue === "Select Nationality" ||
      nokCountryValue === "Country" ||
      nokStateValue === "State"
    ) {
      toast.error("Kindly complete all fields!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
    }
    const completeValue = {
      title_cd: titleValue,
      last_name: lastNameVal,
      first_name: firstNameVal,
      other_names: otherNameVal,
      gender_cd: genderValue,
      corperInvestType: corperInvestType,
      marital_status_cd: "",
      birth_date: dobValue,
      mother_maiden_name: maidenNameValue,
      wedding_anniversary_date: "",
      nationality_cd: nationalityValue,
      mobile_phone_no: phoneNumberVal,
      alternate_phone_no: "",
      primary_email_address: emailVal,
      alternate_email_address: "",
      address_street: contactAddressVal,
      address_city: "",
      address_state_cd: stateValue,
      address_country_cd: countryValue,
      address_zip_code: "",
      occupation: "",
      employer_name: "",
      employment_job_title: "",
      employer_reference: "",
      employer_address_street: "",
      employer_address_city: "",
      employer_address_country_cd: "",
      estimated_annual_income: "",
      bank_cd: bankVal,
      bank_account_name: accountNameVal,
      bank_account_no: accountNumber,
      bank_branch_name: "",
      bank_address_details: "",
      bank_bvn_no: bvn,
      next_of_kin_title_cd: "",
      next_of_kin_last_name: nokLastNameVal,
      next_of_kin_first_name: nokFirstNameVal,
      next_of_kin_other_names: "",
      next_of_kin_gender_cd: nokGenderValue,
      next_of_kin_relationship_cd: relationshipValue,
      next_of_kin_telephone: nokPhoneNumberVal,
      next_of_kin_email_address: nokEmailAddressVal,
      next_of_kin_address_street: nokContactAddressVal,
      next_of_kin_address_city: nokStateValue,
      next_of_kin_address_country_cd: nokCountryValue,
      next_of_kin_address_zip_code: "",
      identity_doc_type_cd: "",
      identity_doc_name: "",
      identity_doc_no: "",
      identity_doc_issue_date: "",
      identity_doc_expiry_date: "",
      identity_doc_issue_authority: "",
      location_cd: "",
      external_reference1: "",
      external_reference2: "",
      retain_customer_id: "",
    };
    formCtx.pushInfo(completeValue);

    var someVal = JSON.stringify(completeValue);

    setPayload(someVal);
    localStorage.setItem("completedValue", someVal);
    if (employmentStatus === "" || employmentStatus === "Employment Status" || employmentStatus === "Unemployed") {
      localStorage.setItem("regPayLoad", someVal);
      navigate("/upload");
    } else {
      setShowPage2(true);
      console.log(completeValue)

    }
  };
  function submitForm() {
    let newPayload = JSON.parse(localStorage.getItem("completedValue"));

    const designationVal = designation.current.value;
    const employerNameVal = employerName.current.value;
    const jobTitleVal = jobTitle.current.value;
    const employerContactAddressVal = employerContactAddress.current.value;
    const employerCountryCodeVal = employerCountry.current.value;
    const employerStateValue = employerState.current.value;
    if (
      designationVal === "" ||
      employerNameVal === "" ||
      jobTitleVal === "" ||
      jobTitleVal === "" ||
      employerContactAddressVal === "" ||
      employerCountryCodeVal === "Employer Country" ||
      employerCountryCodeVal === "" ||
      employerStateValue === "Employer State" ||
      employerStateValue === ""
    ) {
      toast.error("Kindly complete all fields!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.log("Kindly Complete All fields");
      return;
    }
    newPayload.employer_address_country_cd = employerCountryCodeVal;
    newPayload.employer_address_city_cd = employerStateValue;
    newPayload.employer_name = employerNameVal;
    newPayload.employment_job_title = jobTitleVal;
    newPayload.employer_address_street = employerContactAddressVal;
    var someVal = JSON.stringify(newPayload);
    localStorage.setItem("regPayLoad", someVal);
    navigate("/upload");
    setShowPage2(false);
  }
  return (
    <>
      {/* <center>
        <h4 style={{marginTop:"10px"}}>CREATE ACCOUNT</h4>
      </center> */}
      <div className="form_collector">
        <ToastContainer />
        <Navbar/>
        <br/><br/><br/>
        {!showPage2 ? (
          <div className="form_wrapper">
            <div className="form_container">
              <div className="title_container logo_container">
                {/* <img
              src={logo}
              style={{ width: "10%", minWidth: "40px" }}
              onClick={() => {
                navigate("/", { replace: true });
              }}
              alt="logo"
            /> */}
              </div>
              <div>
                <div className="">
                  <form onSubmit={sendDataHandler}>
                    <div className="row ">
                      <div className="col-md-4">
                        <div
                          className={`input_field select_option ${classes.account__details
                            } ${!titleValid ? classes.not_valid : ""}`}
                        >
                          {/* <span><i aria-hidden="true" className="fa fa-envelope"></i></span> */}
                          <select
                            ref={title}
                            onChange={titleChangeHandler}
                            onBlur={titleChangeHandler}
                          >
                            <option selected>Select Title</option>
                            {titleList.map((tit) => {
                              return (
                                <option value={tit.TITLE_CD}>
                                  {tit.TITLE_DSC}
                                </option>
                              );
                            })}
                          </select>
                          <div className="select_arrow"></div>
                          {!titleValid && (
                            <p style={{ float: "left" }} className="errorInvalid">
                              please select a title
                            </p>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="row px-2">
                      <div className="col-md-4">
                        <div
                          className={`input_field ${!firstNameValid ? classes.not_valid : ""
                            }`}
                        >
                          <span>
                            <i aria-hidden="true" className={`.fa fa-user`}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-person"
                                viewBox="0 0 16 16"
                              >
                                <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z" />
                              </svg>
                            </i>
                          </span>
                          <input
                            type="text"
                            name="name"
                            placeholder="First Name"
                            ref={firstName}
                            onBlur={firstNameChangeHandler}
                            onChange={firstNameChangeHandler}
                          />
                        </div>
                        {!firstNameValid && (
                          <p className="errorInvalid">
                            first name cannot be empty
                          </p>
                        )}
                      </div>
                      <div className="col-md-4">
                        <div
                          className={`input_field ${!lastNameValid ? classes.not_valid : ""
                            }`}
                        >
                          <span>
                            <i aria-hidden="true" className={`fa fa-user`}>
                              {" "}
                              <span>
                                <i aria-hidden="true" className={`.fa fa-user`}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-person"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z" />
                                  </svg>
                                </i>
                              </span>
                            </i>
                          </span>
                          <input
                            type="text"
                            name="name"
                            placeholder="Last Name"
                            ref={lastName}
                            onBlur={lastNameChangeHandler}
                            onChange={lastNameChangeHandler}
                          />
                        </div>
                        {!lastNameValid && (
                          <p className="errorInvalid">
                            last name cannot be empty
                          </p>
                        )}
                      </div>
                      <div className="col-md-4">
                        <div
                          className={`input_field ${!otherNameValid ? classes.not_valid : ""
                            }`}
                        >
                          <span>
                            <i aria-hidden="true" className="fa fa-user">
                              {" "}
                              <span>
                                <i aria-hidden="true" className={`.fa fa-user`}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-person"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z" />
                                  </svg>
                                </i>
                              </span>
                            </i>
                          </span>
                          <input
                            type="text"
                            name="name"
                            placeholder="Other Name"
                            ref={otherName}
                          />
                        </div>
                        {!otherNameValid && (
                          <p className="errorInvalid">name cannot be empty</p>
                        )}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className={classes.emailinfo}>
                          <div
                            className={`input_field ${!emailValid ? classes.not_valid : ""
                              }`}
                          >
                            <span>
                              <i aria-hidden="true" className="fa fa-envelope">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-envelope-at"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2H2Zm3.708 6.208L1 11.105V5.383l4.708 2.825ZM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2-7-4.2Z" />
                                  <path d="M14.247 14.269c1.01 0 1.587-.857 1.587-2.025v-.21C15.834 10.43 14.64 9 12.52 9h-.035C10.42 9 9 10.36 9 12.432v.214C9 14.82 10.438 16 12.358 16h.044c.594 0 1.018-.074 1.237-.175v-.73c-.245.11-.673.18-1.18.18h-.044c-1.334 0-2.571-.788-2.571-2.655v-.157c0-1.657 1.058-2.724 2.64-2.724h.04c1.535 0 2.484 1.05 2.484 2.326v.118c0 .975-.324 1.39-.639 1.39-.232 0-.41-.148-.41-.42v-2.19h-.906v.569h-.03c-.084-.298-.368-.63-.954-.63-.778 0-1.259.555-1.259 1.4v.528c0 .892.49 1.434 1.26 1.434.471 0 .896-.227 1.014-.643h.043c.118.42.617.648 1.12.648Zm-2.453-1.588v-.227c0-.546.227-.791.573-.791.297 0 .572.192.572.708v.367c0 .573-.253.744-.564.744-.354 0-.581-.215-.581-.8Z" />
                                </svg>
                              </i>
                            </span>
                            <input
                              type="email"
                              name="email"
                              placeholder="Email"
                              ref={email}
                              onBlur={emailChangeHandler}
                              onChange={emailChangeHandler}
                            />
                          </div>
                          {!emailValid && (
                            <p className="errorInvalid">invalid email</p>
                          )}
                        </div>
                      </div>

                      <div className="col-md-6">
                        {" "}
                        <div className={classes.emailinfo}>
                          <div
                            className={`input_field ${!phoneNumberValid ? classes.not_valid : ""
                              }`}
                          >
                            <span>
                              <i aria-hidden="true" className="fa fa-envelope">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-telephone"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
                                </svg>
                              </i>
                            </span>
                            <input
                              type="number"
                              name="Phone Number"
                              placeholder="Phone Number"
                              ref={phoneNumber}
                              onBlur={phoneNumberChangeHandler}
                              onChange={phoneNumberChangeHandler}
                            />
                          </div>
                          {!phoneNumberValid && (
                            <p className="errorInvalid">phone number not valid</p>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-3">
                        {" "}
                        <div className={classes.emailinfo}>
                          <div
                            className={`input_field select_option ${classes.account__details
                              } ${!genderValid ? classes.not_valid : ""}`}
                          >
                            {/* <span><i aria-hidden="true" className="fa fa-envelope"></i></span> */}
                            <select
                              ref={gender}
                              value={gend}
                              onChange={genderChangeHandler}
                              onBlur={genderChangeHandler}
                            >
                              <option selected>Select Gender</option>
                              <option>Male</option>
                              <option>Female</option>
                            </select>
                            <div className="select_arrow"></div>
                          </div>
                          {!genderValid && (
                            <p className="errorInvalid">please select a gender</p>
                          )}
                        </div>
                      </div>
                      {/* date of birth input */}
                      <div className="col-md-3">
                        {" "}
                        <div className={classes.emailinfo}>
                          <div
                            className={`input_field ${!dobValid ? classes.not_valid : ""
                              }`}
                          >
                            <span>
                              <i aria-hidden="true" className="fa fa-envelope">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar-event" viewBox="0 0 16 16">
                                  <path d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z" />
                                  <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
                                </svg>
                              </i>
                            </span>
                            <input
                              type="text"
                              name="dob"
                              placeholder="Date of birth"
                              ref={dateOfBirth}
                              onBlur={dobChangeHandler}
                              onChange={dobChangeHandler}
                              onFocus={(dobOnFocusHandler)}
                            />
                          </div>
                          {!dobValid && (
                            <p className="errorInvalid">
                              Date of birth cannot be empty
                            </p>
                          )}
                        </div>
                      </div>
                      {/* End date of birth input */}
                      <div className="col-md-6">
                        {" "}
                        <div className={classes.emailinfo}>
                          <div
                            className={`input_field ${!maidenValid ? classes.not_valid : ""
                              }`}
                          >
                            <span>
                              <i aria-hidden="true" className="fa fa-envelope">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-person"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z" />
                                </svg>
                              </i>
                            </span>
                            <input
                              type="text"
                              name="email"
                              placeholder="Mother's maiden name"
                              ref={maidenName}
                              onBlur={maidenNameChangeHandler}
                              onChange={maidenNameChangeHandler}
                            />
                          </div>
                          {!maidenValid && (
                            <p className="errorInvalid">
                              maiden name cannot be empty
                            </p>
                          )}
                        </div>
                      </div>
                    </div>

                    <div
                      className={`input_field ${!contactValid ? classes.not_valid : ""
                        }`}
                    >
                      <span>
                        <i aria-hidden="true" className="fa fa-envelope">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-geo-alt"
                            viewBox="0 0 16 16"
                          >
                            <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 0 1 8 14.58a31.481 31.481 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10z" />
                            <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                          </svg>
                        </i>
                      </span>
                      <input
                        type="text"
                        name="address"
                        placeholder="Contact Address"
                        onBlur={contactAddressChangeHandler}
                        onChange={contactAddressChangeHandler}
                        ref={contactAddress}
                      />
                    </div>
                    {!contactValid && (
                      <p className="errorInvalid">
                        contact address cannot be empty
                      </p>
                    )}
                    <div className="row">
                      <div className="col-md-4">
                        {" "}
                        <div className={classes.emailinfo}>
                          <div
                            className={`input_field select_option ${classes.account__details
                              } ${!countryValid ? classes.not_valid : ""}`}
                          >
                            {/* <span><i aria-hidden="true" className="fa fa-envelope"></i></span> */}
                            <select
                              ref={country}
                              onChange={(e) =>
                                countryChangeHandler(e.target.value)
                              }
                              onBlur={(e) => countryChangeHandler(e.target.value)}
                            >
                              <option selected>Select Country</option>
                              {countryList.map((cou) => {
                                return (
                                  <option value={cou.COUNTRY_CD}>
                                    {cou.COUNTRY_DSC}
                                  </option>
                                );
                              })}
                            </select>
                            <div className="select_arrow"></div>
                          </div>
                          {!countryValid && (
                            <p className="errorInvalid">
                              please select a country
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-4">
                        {" "}
                        <div className={classes.emailinfo}>
                          <div
                            className={`input_field select_option ${classes.account__details
                              } ${!stateValid ? classes.not_valid : ""}`}
                          >
                            {/* <span><i aria-hidden="true" className="fa fa-envelope"></i></span> */}
                            <select
                              ref={state}
                              onChange={(e) => stateChangeHandler(e.target.value)}
                              onBlur={(e) => stateChangeHandler(e.target.value)}
                            >
                              <option selected>Select State</option>
                              {stList.map((lga) => {
                                return (
                                  <option value={lga.STATE_CD}>
                                    {lga.STATE_DSC}
                                  </option>
                                );
                              })}
                            </select>
                            <div className="select_arrow"></div>
                          </div>
                          {!stateValid && (
                            <p className="errorInvalid">please select state</p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className={classes.emailinfo}>
                          <div
                            className={`input_field select_option ${classes.account__details
                              } ${!lgaValid ? classes.not_valid : ""}`}
                          >
                            <select
                              ref={lga}
                              value={lg}
                              onChange={lgaChangeHandler}
                              onBlur={lgaChangeHandler}
                            >
                              <option className={classes.select_option} selected>
                                Select LGA
                              </option>
                              {lgList.map((lga) => {
                                return (
                                  <option value={lga.LGA_CD}>
                                    {lga.LGA_DSC}
                                  </option>
                                );
                              })}
                            </select>
                            <div className="select_arrow"></div>
                          </div>
                          {!lgaValid && (
                            <p className="errorInvalid">please select LGA</p>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div
                          className={`input_field select_option ${classes.account__details
                            } ${!nationalityValid ? classes.not_valid : ""}`}
                        >
                          <select
                            ref={nationality}
                            onChange={nationalityChangeHandler}
                            onBlur={nationalityChangeHandler}
                          >
                            <option className={classes.select_option} selected>
                              Select Nationality
                            </option>
                            {nationalityList.map((cou) => {
                              return (
                                <option value={cou.NATIONALITY_CD}>
                                  {cou.NATIONALITY_DSC}
                                </option>
                              );
                            })}
                          </select>
                          <div className="select_arrow"></div>
                        </div>
                        {!nationalityValid && (
                          <p className="errorInvalid">
                            please select nationality
                          </p>
                        )}
                      </div>
                      <div className="col-md-6">
                        <div
                          className={`input_field select_option ${classes.account__details
                            } ${!employmentValid ? classes.not_valid : ""}`}
                        >
                          <select
                            ref={employment}
                            value={employmentStatus}
                            onChange={employmentChangeHandler}
                            onBlur={employmentChangeHandler}
                          >
                            <option selected className={classes.select_option}>Employment Status</option>
                            <option>Employed</option>
                            <option>Unemployed</option>
                          </select>
                          <div className="select_arrow"></div>
                        </div>
                        {!employmentValid && (
                          <p className="errorInvalid">please select employment status</p>
                        )}
                      </div>
                      <div className="col-md-6">

                      </div>

                    </div>
                    <div className="row">
                      <div className="col-md-6">

                        <div className={classes.emailinfo}>
                          <div
                            className={`input_field select_option ${classes.account__details
                              } ${!bankValid ? classes.not_valid : ""}`}
                          >
                            <select
                              ref={bank}
                              value={bk}
                              onChange={bankChangeHandler}
                              onBlur={bankChangeHandler}
                            >
                              <option className={classes.select_option} selected>
                                Select Bank
                              </option>
                              {bankList.map((bank) => {
                                return (
                                  <option value={bank.BANK_CD}>
                                    {bank.BANK_DSC}
                                  </option>
                                );
                              })}
                            </select>
                            <div className="select_arrow"></div>
                          </div>
                          {!bankValid && (
                            <p className="errorInvalid">please select a bank</p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        {" "}
                        <div className={classes.emailinfo}>
                          <div
                            className={`input_field ${!accountValid ? classes.not_valid : ""
                              }`}
                          >
                            <span>
                              <i aria-hidden="true" className="fa fa-envelope">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-person"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z" />
                                </svg>
                              </i>
                            </span>
                            <input
                              type="text"
                              ref={accountName}
                              name="Account Name"
                              placeholder="Account Name"
                              onChange={accountNameChangeHandler}
                              onBlur={accountNameChangeHandler}
                            />
                          </div>
                          {!accountValid && (
                            <p className="errorInvalid">
                              account name cannot be empty
                            </p>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="row ">
                      <div className="col-md-6">
                        <label for="otp" style={{ float: "left" }}>
                          Account No:
                        </label>
                        <div className="otp-field" id="otp">
                          <OtpInput
                            value={accountNumber}
                            inputStyle={{
                              width: "20px",
                              padding: "5px 5px 2px  !important",
                              height: "28px !important",
                              fontSize: "14px",
                              textAlign: "left",
                              borderRadius: "2px",
                              margin: "1px",
                              outline: "none",
                              transition: "all 0.1s",
                              border: accountNumberValid ? "" : "red solid 1px",
                            }}
                            onChange={handleAccountNumberChange}
                            onBlur={handleAccountNumberChange}
                            numInputs={10}
                          />
                        </div>
                        {!accountNumberValid && (
                          <p style={{ float: "left" }} className="errorInvalid">
                            account number cannot be less than 10 digits
                          </p>
                        )}
                      </div>
                      <div className="col-md-6">
                        <div>
                          <label for="bvn" style={{ float: "left" }}>
                            BVN:
                          </label>
                          <div className="otp-field" id="bvn" name="bvn">
                            <OtpInput
                              value={bvn}
                              inputStyle={{
                                width: "20px",
                                padding: "5px 5px 2px  !important",
                                height: "28px !important",
                                "font-size": "14px",
                                "text-align": "left",
                                "border-radius": "2px",
                                margin: "1px",
                                outline: "none",
                                transition: "all 0.1s",
                                border: bvnValid ? "" : "red solid 1px",
                              }}
                              onChange={handleBvnChange}
                              onBlur={handleBvnChange}
                              numInputs={11}
                            />
                          </div>
                          {!bvnValid && (
                            <p style={{ float: "left" }} className="errorInvalid">
                              bvn cannot be less than 11 digits
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="next__kin">
                      <div
                        style={{
                          color: "white",
                          backgroundColor: "#f15a29",
                          padding: "3px",
                        }}
                      >
                        {" "}
                        <b>Next of Kin Details</b>
                      </div>

                      <div className="row ">
                        <div className="col-md-6">
                          <div>
                            <div
                              className={`input_field ${!nokFirstNameValid ? classes.not_valid : ""
                                }`}
                            >
                              <span>
                                <i aria-hidden="true" className={`fa "fa-user`}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-person"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z" />
                                  </svg>
                                </i>
                              </span>
                              <input
                                type="text"
                                ref={nokFirstName}
                                name="name"
                                placeholder="First Name"
                                onChange={nokFirstNameChangeHandler}
                                onBlur={nokFirstNameChangeHandler}
                              />
                            </div>
                            {!nokFirstNameValid && (
                              <p className="errorInvalid">name cannot be empty</p>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          {" "}
                          <div>
                            <div
                              className={`input_field ${!nokLastNameValid ? classes.not_valid : ""
                                }`}
                            >
                              <span>
                                <i aria-hidden="true" className={`fa fa-user`}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-person"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z" />
                                  </svg>
                                </i>
                              </span>
                              <input
                                type="text"
                                name="name"
                                placeholder="Last Name"
                                onChange={nokLastNameChangeHandler}
                                onBlur={nokLastNameChangeHandler}
                                ref={nokLastName}
                              />
                            </div>
                            {!nokLastNameValid && (
                              <p className="errorInvalid">name cannot be empty</p>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div
                            className={`input_field select_option ${classes.account__details
                              } ${!nokRelationshipValid ? classes.not_valid : ""}`}
                          >
                            <select
                              ref={nokRelationship}
                              value={nokRelation}
                              onBlur={nokRelationshipChangeHandler}
                              onChange={nokRelationshipChangeHandler}
                            >
                              <option className={classes.select_option} selected>
                                Relationship
                              </option>
                              {relationshipList.map((relate) => {
                                return (
                                  <option value={relate.RELATIONSHIP_CD}>
                                    {relate.RELATIONSHIP_DSC}
                                  </option>
                                );
                              })}
                            </select>
                            <div className="select_arrow"></div>
                          </div>
                          {!nokRelationshipValid && (
                            <p className="errorInvalid">
                              please enter relationship
                            </p>
                          )}
                        </div>
                        <div className="col-md-6">
                          <div
                            className={`input_field select_option ${classes.account__details
                              } ${!nokGenderValid ? classes.not_valid : ""}`}
                          >
                            <select
                              ref={nokGender}
                              value={nokGend}
                              onBlur={nokGenderChangeHandler}
                              onChange={nokGenderChangeHandler}
                            >
                              <option className={classes.select_option} selected>
                                Gender
                              </option>
                              <option className={classes.select_option}>
                                Male
                              </option>
                              <option className={classes.select_option}>
                                Female
                              </option>
                            </select>
                            <div className="select_arrow"></div>
                          </div>
                          {!nokGenderValid && (
                            <p className="errorInvalid">please select gender</p>
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div
                            className={`input_field ${!nokPhoneNumberValid ? classes.not_valid : ""
                              }`}
                          >
                            <span>
                              <i aria-hidden="true" className="fa fa-envelope">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-telephone"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
                                </svg>
                              </i>
                            </span>
                            <input
                              type="number"
                              name="email"
                              placeholder="Phone Number"
                              onChange={nokPhoneNumberChangeHandler}
                              onBlur={nokPhoneNumberChangeHandler}
                              ref={nokPhoneNumber}
                            />
                          </div>
                          {!nokPhoneNumberValid && (
                            <p className="errorInvalid">phone number not valid</p>
                          )}
                        </div>
                        <div className="col-md-6">
                          <div
                            className={`input_field ${!nokEmailValid ? classes.not_valid : ""
                              }`}
                          >
                            <span>
                              <i aria-hidden="true" className="fa fa-envelope">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-envelope-at"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2H2Zm3.708 6.208L1 11.105V5.383l4.708 2.825ZM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2-7-4.2Z" />
                                  <path d="M14.247 14.269c1.01 0 1.587-.857 1.587-2.025v-.21C15.834 10.43 14.64 9 12.52 9h-.035C10.42 9 9 10.36 9 12.432v.214C9 14.82 10.438 16 12.358 16h.044c.594 0 1.018-.074 1.237-.175v-.73c-.245.11-.673.18-1.18.18h-.044c-1.334 0-2.571-.788-2.571-2.655v-.157c0-1.657 1.058-2.724 2.64-2.724h.04c1.535 0 2.484 1.05 2.484 2.326v.118c0 .975-.324 1.39-.639 1.39-.232 0-.41-.148-.41-.42v-2.19h-.906v.569h-.03c-.084-.298-.368-.63-.954-.63-.778 0-1.259.555-1.259 1.4v.528c0 .892.49 1.434 1.26 1.434.471 0 .896-.227 1.014-.643h.043c.118.42.617.648 1.12.648Zm-2.453-1.588v-.227c0-.546.227-.791.573-.791.297 0 .572.192.572.708v.367c0 .573-.253.744-.564.744-.354 0-.581-.215-.581-.8Z" />
                                </svg>
                              </i>
                            </span>
                            <input
                              type="email"
                              name="email"
                              placeholder="Email Address"
                              ref={nokEmailAddress}
                              onBlur={nokEmailChangeHandler}
                              onChange={nokEmailChangeHandler}
                            />
                          </div>
                          {!nokEmailValid && (
                            <p className="errorInvalid">Email not valid</p>
                          )}
                        </div>
                      </div>
                      <div
                        className={`input_field ${!nokContactAddressValid ? classes.not_valid : ""
                          }`}
                      >
                        <span>
                          <i aria-hidden="true" className="fa fa-envelope">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-geo-alt"
                              viewBox="0 0 16 16"
                            >
                              <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 0 1 8 14.58a31.481 31.481 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10z" />
                              <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                            </svg>
                          </i>
                        </span>
                        <input
                          type="text"
                          name="address"
                          ref={nokContactAddress}
                          placeholder="Contact Address"
                          onChange={nokContactAddressChangeHandler}
                          onBlur={nokContactAddressChangeHandler}
                        />
                      </div>
                      {!nokContactAddressValid && (
                        <p className="errorInvalid">
                          contact address cannot be empty
                        </p>
                      )}
                      <div className="row">
                        <div className="col-md-6">
                          <div
                            className={`input_field select_option ${classes.account__details
                              } ${!nokCountryValid ? classes.not_valid : ""}`}
                          >
                            <select
                              ref={nokCountry}
                              onBlur={(e) =>
                                nokCountryChangeHandler(e.target.value)
                              }
                              onChange={(e) =>
                                nokCountryChangeHandler(e.target.value)
                              }
                            >
                              <option className={classes.select_option} selected>
                                Country
                              </option>
                              {countryList.map((cou) => {
                                return (
                                  <option value={cou.COUNTRY_CD}>
                                    {cou.COUNTRY_DSC}
                                  </option>
                                );
                              })}
                            </select>
                            <div className="select_arrow"></div>
                          </div>
                          {!nokCountryValid && (
                            <p className="errorInvalid">
                              please select a country
                            </p>
                          )}
                        </div>
                        <div className="col-md-6">
                          <div
                            className={`input_field select_option ${classes.account__details
                              } ${!nokStateValid ? classes.not_valid : ""}`}
                          >
                            <select
                              ref={nokState}
                              onBlur={nokStateChangeHandler}
                              onChange={nokStateChangeHandler}
                            >
                              <option className={classes.select_option} selected>
                                State
                              </option>
                              {nokLGA.map((lga) => {
                                return (
                                  <option value={lga.STATE_CD}>
                                    {lga.STATE_DSC}
                                  </option>
                                );
                              })}
                            </select>
                            <div className="select_arrow"></div>
                          </div>
                          {!nokStateValid && (
                            <p className="errorInvalid">please select a state</p>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className={`${classes.submit_sect} col-md-3`}>
                      <input
                        style={{ cursor: "pointer" }}
                        className="button"
                        type="submit"
                        value="Next"
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="form_wrapper">
            <div className="form_container">
              <div className="title_container logo_container"></div>
              <div>
                <div className="">
                  <form onSubmit={submitForm}>
                    <div className="next__kin">
                      <div
                        style={{
                          color: "white",
                          backgroundColor: "#f15a29",
                          padding: "3px",
                        }}
                      >
                        {" "}
                        <b>Employment Details</b>
                      </div>

                      <div className="row ">
                        <div className="col-md-6">
                          <div>
                            <div
                              className={`input_field ${!employerNameValid ? classes.not_valid : ""
                                }`}
                            >
                              <span>
                                <i aria-hidden="true" className={`fa "fa-user`}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-person"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z" />
                                  </svg>
                                </i>
                              </span>
                              <input
                                type="text"
                                ref={employerName}
                                name="employername"
                                placeholder="Employer Name"
                                onChange={employerNameChangeHandler}
                                onBlur={employerNameChangeHandler}
                              />
                            </div>
                            {!employerNameValid && (
                              <p className="errorInvalid">
                                Employer name cannot be empty
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="col-md-4">
                          {" "}
                          <div>
                            <div
                              className={`input_field ${!nokLastNameValid ? classes.not_valid : ""
                                }`}
                            >
                              <span>
                                <i aria-hidden="true" className={`fa fa-user`}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-person"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z" />
                                  </svg>
                                </i>
                              </span>
                              <input
                                type="text"
                                name="name"
                                placeholder="Job Title"
                                onChange={jobTitleChangeHandler}
                                onBlur={jobTitleChangeHandler}
                                ref={jobTitle}
                              />
                            </div>
                            {!jobTitleValid && (
                              <p className="errorInvalid">
                                Job Title cannot be empty
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="col-md-4">
                          {" "}
                          <div>
                            <div
                              className={`input_field ${!designationValid ? classes.not_valid : ""
                                }`}
                            >
                              <span>
                                <i aria-hidden="true" className={`fa fa-user`}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-person"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z" />
                                  </svg>
                                </i>
                              </span>
                              <input
                                type="text"
                                name="designation"
                                placeholder="Designation"
                                onChange={designationChangeHandler}
                                onBlur={designationChangeHandler}
                                ref={designation}
                              />
                            </div>
                            {!designationValid && (
                              <p className="errorInvalid">
                                Designation cannot be empty
                              </p>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <div
                            className={`input_field select_option ${classes.account__details
                              } ${!employerCountryValid ? classes.not_valid : ""}`}
                          >
                            <select
                              ref={employerCountry}
                              onBlur={(e) =>
                                employerCountryChangeHandler(e.target.value)
                              }
                              onChange={(e) =>
                                employerCountryChangeHandler(e.target.value)
                              }
                            >
                              <option className={classes.select_option} selected>
                                Employer Country
                              </option>
                              {countryList.map((cou) => {
                                return (
                                  <option value={cou.COUNTRY_CD}>
                                    {cou.COUNTRY_DSC}
                                  </option>
                                );
                              })}
                            </select>
                            <div className="select_arrow"></div>
                          </div>
                          {!nokCountryValid && (
                            <p className="errorInvalid">
                              please select a country
                            </p>
                          )}
                        </div>
                        <div className="col-md-6">
                          <div
                            className={`input_field select_option ${classes.account__details
                              } ${!employerStateValid ? classes.not_valid : ""}`}
                          >
                            <select
                              ref={employerState}
                              onBlur={employerStateChangeHandler}
                              onChange={employerStateChangeHandler}
                            >
                              <option className={classes.select_option} selected>
                                Employer State
                              </option>
                              {employerState.map((state) => {
                                return (
                                  <option value={state.STATE_CD}>
                                    {state.STATE_DSC}
                                  </option>
                                );
                              })}
                            </select>
                            <div className="select_arrow"></div>
                          </div>
                          {!employerStateValid && (
                            <p className="errorInvalid">please select a state</p>
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <div
                          className={` ${!employerContactAddressValid ? classes.not_valid : ""
                            }`}
                        >
                          <textarea
                            style={{
                              width: "100%",
                              border: "1px solid #cccccc",
                              padding: "8px 10px 9px 13px",
                            }}
                            type="text"
                            name="employeraddress"
                            ref={employerContactAddress}
                            placeholder="Employer Contact Address"
                            onChange={employerContactAddressChangeHandler}
                            onBlur={employerContactAddressChangeHandler}
                          />
                        </div>
                        {!employerContactAddressValid && (
                          <p className="errorInvalid">
                            Employer contact address cannot be empty
                          </p>
                        )}
                      </div>
                    </div>

                    <div className={`${classes.submit_sect} col-md-3`}>
                      <input
                        style={{ cursor: "pointer" }}
                        className="button"
                        type="submit"
                        value="Next"
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer/>
    </>
  );
};

export default RegForm;
